import { Typography } from "zudoku/components"
import { nibssApiDescriptors } from "../data/third-party-apis/api-info"
import { ApiCard } from "../components/product/ApiCard"

export const NibssApis = () => (
    <>
        <Typography className="my-5 max-w-none">
            <h1>NIBSS APIs</h1>
            <p>
                Nigeria Inter-Bank Settlement System APIs for payments, settlements,
                identity verification, and Bank Verification Number (BVN) services.
            </p>
        </Typography>
        <div className="grid grid-cols-2 gap-4 my-5">
            {nibssApiDescriptors.map(({ name, description, path }) => (
                <ApiCard key={name} title={name} description={description} path={path} />
            ))}
        </div>
    </>
)